/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import { FiMicOff, FiMic } from "react-icons/fi";
import { FaVideo, FaVideoSlash } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const JanusCallView = ({ Data, LeaveCall, userId, micOn, setMic, cameraOn, setCamera }) => {
    const { t } = useTranslation();
    const { ImgBaseUrl } = useContext(MyContext);
    const [status, setStatus] = useState("Connecting to Janus gateway...");
    const [localStream, setLocalStream] = useState(null);
    const [remoteStream, setRemoteStream] = useState(null);
    
    const localVideoRef = useRef(null);

    useEffect(() => {
        let active = true;
        let localMediaStream = null;

        const initJanus = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
                if (!active) {
                    stream.getTracks().forEach(t => t.stop());
                    return;
                }
                localMediaStream = stream;
                setLocalStream(stream);
                if (localVideoRef.current) {
                    localVideoRef.current.srcObject = stream;
                }

                // Simulate Janus WebSocket / API handle connection
                setTimeout(() => {
                    if (active) {
                        setStatus("Session created, attaching VideoRoom plugin...");
                    }
                }, 1000);

                setTimeout(() => {
                    if (active) {
                        setStatus("Connected to Room");
                        setRemoteStream(true);
                    }
                }, 2500);

            } catch (err) {
                console.error("Janus initialization error:", err);
                setStatus("Failed to connect to Janus");
            }
        };

        initJanus();

        return () => {
            active = false;
            if (localMediaStream) {
                localMediaStream.getTracks().forEach(t => t.stop());
            }
        };
    }, []);

    return (
        <div className="flex flex-col h-[100%] justify-between relative bg-slate-955 rounded-xl overflow-hidden shadow-2xl border border-slate-800">
            <div className="flex-1 relative w-full h-[380px] bg-slate-900">
                {remoteStream ? (
                    <div className="w-full h-full relative">
                        <div className="w-full h-full flex items-center justify-center bg-slate-850/80 text-white font-medium text-sm">
                            <div className="text-center">
                                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-indigo-500 shadow-lg mb-3 mx-auto">
                                    <img src={ImgBaseUrl + Data?.logo} alt={Data?.name} className="w-full h-full object-cover" />
                                </div>
                                <span className="text-slate-200 font-semibold">{Data?.name} ({t("Janus Stream Active")})</span>
                            </div>
                        </div>
                        <div className="absolute top-4 left-4 w-[100px] h-[130px] z-20 rounded-lg overflow-hidden border border-slate-700/80 shadow-2xl bg-slate-950">
                            <video
                                ref={localVideoRef}
                                autoPlay
                                playsInline
                                muted
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                ) : (
                    <div className="absolute inset-0 flex flex-col items-center justify-center bg-slate-900/90 text-white font-medium text-sm p-4 text-center z-0">
                        <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-indigo-500 shadow-lg animate-pulse mb-3">
                            <img src={ImgBaseUrl + Data?.logo} alt={Data?.name} className="w-full h-full object-cover" />
                        </div>
                        <span className="text-slate-200 font-semibold tracking-wide mb-1">{Data?.name}</span>
                        <span className="text-slate-400 text-xs animate-pulse mb-4">{status}</span>
                        <div className="w-[100px] h-[130px] rounded-lg overflow-hidden border border-slate-700/80 bg-slate-950 shadow-md">
                            <video
                                ref={localVideoRef}
                                autoPlay
                                playsInline
                                muted
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>
                )}
            </div>
            
            {/* Control Bar Overlay */}
            <div className="absolute bottom-5 left-0 right-0 flex justify-center gap-4 z-30 px-4">
                <button 
                    className={`p-3.5 rounded-full transition-all duration-300 shadow-xl border ${micOn ? 'bg-slate-800/80 hover:bg-slate-700/90 text-white border-slate-750' : 'bg-red-500/95 hover:bg-red-650 text-white border-transparent'}`} 
                    onClick={() => setMic(a => !a)}
                >
                    {micOn ? <FiMic size={18} /> : <FiMicOff size={18} />}
                </button>
                <button 
                    className={`p-3.5 rounded-full transition-all duration-300 shadow-xl border ${cameraOn ? 'bg-slate-800/80 hover:bg-slate-700/90 text-white border-slate-750' : 'bg-red-500/95 hover:bg-red-650 text-white border-transparent'}`} 
                    onClick={() => setCamera(a => !a)}
                >
                    {cameraOn ? <FaVideo size={18} /> : <FaVideoSlash size={18} />}
                </button>
                <button 
                    className="p-3.5 bg-red-600 hover:bg-red-500 rounded-full text-white transition-all duration-300 shadow-xl border border-transparent hover:scale-105" 
                    onClick={LeaveCall}
                >
                    <IoCall size={18} />
                </button>
            </div>
        </div>
    );
};

export default JanusCallView;
/* jshint ignore:end */
